import React, { FC ,useMemo} from 'react'
import AddPostModal from '../../components/Calendar/ModalAddPost'
import ModalPostType from '../../components/Calendar/ModalPostType'
import SchedulePostModal from '../../components/Calendar/ModalSchedulePost'
import Navigation from '../../components/Navigation'
import AddProjectModal from '../../components/Settings/AddProjectModal'
import EditProfileModal from '../../components/Settings/EditProfileModal'
import { useSelector }  from '../../store/index'
import NotificationSettingModal from '../../components/Settings/NotificationSettingModal'
import HashModal from '../../components/Settings/HastagModal';
import Roles from '../../models/roles'

interface MainProps { }

const Main: FC<MainProps> = ({ children }) => {

  const {location} = useSelector(({router:{location}})=>({location}));

  const { user } = useSelector((state) => ({
    user: state.auth.user,
  }))

  const showSideBar = useMemo(()=>{
    const result = location.pathname.split('/');
    return result[1] === 'billing'?false:true;
  },[location])


  const showNavigation = user?.agency_role === Roles.INTERNAL_APPROVER  || user?.agency_role === Roles.EXTERNAL_APPROVER;

  return (
    <div className='general-layout'>
      {showNavigation ?
        <div>
          <Navigation isEnablePageNavigation={false} />
        </div> :
        <div className={showSideBar?'general-layout__navigation':''}>
          <Navigation isEnablePageNavigation={showSideBar} />
        </div>
      }

      {/*<div className={showSideBar?'general-layout__navigation':''}>*/}
      {/*  <Navigation isEnablePageNavigation={showSideBar} />*/}
      {/*</div>*/}

      <div className='general-layout__content'>{children}</div>
      <AddProjectModal />
      <EditProfileModal />
      <AddPostModal />
      <ModalPostType />
      <SchedulePostModal />
      <NotificationSettingModal/>
      <HashModal/>
    </div>
  )
}

export default Main
